<template>
	<div class="statistics">
		<transition-group name="fade">
			<div
				v-if="statistics"
				:key="`staticsData`"
				class="statistics__contents"
			>
				<div class="statistics__contents__header">
					{{ statistics.id }} | {{ statistics.brandTitle }} |
					{{ statistics.categoryText }} |
					{{ statistics.productTitle }} |
					{{
						moment(statistics.startOn * 1000).format(
							'YYYY-MM-DD HH:mm'
						)
					}}
					~
					{{
						moment(statistics.endOn * 1000).format(
							'YYYY-MM-DD HH:mm'
						)
					}}
					<span
						class="statistics__contents__header__status"
						:class="{
							'statistics__contents__header__status--open':
								statistics.status === 'open',
						}"
					>
						{{ statistics.status === 'open' ? '전시중' : '비전시' }}
					</span>
					<button
						class="btn-excel statistics__contents__header__excel-download"
						@click="excelDownload"
					>
						엑셀 다운로드
					</button>
				</div>
				<table class="table-main">
					<thead>
						<tr>
							<th>구분</th>
							<th>노출수</th>
							<th>클릭수</th>
							<th>CTR</th>
							<th>일별 조회</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="item in statistics.displayHotEditerLogs"
							:key="item.createdAt"
						>
							<td>{{ item.typeName }}</td>
							<td>{{ item.displayCnt | currency }}</td>
							<td>{{ item.clickCnt | currency }}</td>
							<td>{{ item.ctr }}%</td>
							<td>
								<button
									class="btn bordered"
									@click="
										$router.push({
											path: `/prouct/editor-product/statistics/${statistics.id}/daily/${item.type}`,
										})
									"
								>
									일별통계
								</button>
							</td>
						</tr>
						<tr class="statistics__contents__table__total">
							<td>합계/평균</td>
							<td>{{ statistics.displayTotalCnt | currency }}</td>
							<td>{{ statistics.clickTotalCnt | currency }}</td>
							<td>{{ statistics.totalCtr }}%</td>
							<td>-</td>
						</tr>
					</tbody>
				</table>
			</div>
		</transition-group>
		<div class="statistics__button-wrapper">
			<button
				class="btn blue"
				@click="
					$router.push({ path: '/advertisement/editor-product/list' })
				"
			>
				목록으로
			</button>
		</div>
	</div>
</template>
<script>
	import moment from 'moment';
	import util from '@/util';

	export default {
		name: 'EditorProductStatistics',
		data() {
			return {
				statistics: null,
			};
		},
		mounted() {
			const id = this.$route.params.productId;
			this.$axiosAdmin2
				.get(`/api/hotediter/${id}/static`)
				.then(({ data }) => {
					const categoryText = [
						data.firstCategoryText,
						data.secondCategoryText,
					];

					if (data.thirdCategoryText.trim()) {
						categoryText.push(data.thirdCategoryText);
					}
					data.categoryText = categoryText.join('>');
					this.statistics = data;
				});
		},
		methods: {
			moment,
			async excelDownload() {
				const url = `/api/hotediters/${this.$route.params.productId}/staticExport`;
				const res = await this.$axiosAdmin2.get(url, {
					responseType: 'blob',
				});
				util.exportExcel(res);
			},
		},
	};
</script>
<style lang="scss">
	.fade-enter-active,
	.fade-leave-active {
		transition: all 300ms ease-in-out;
	}

	.fade-enter,
	.fade-leave-to {
		opacity: 0;
	}

	.fade-leave,
	.fade-enter-to {
		opacity: 1;
	}

	.statistics {
		.btn {
			display: inline-block;
		}
	}

	.statistics__contents__header {
		padding: 1em 0;
		font-size: 1rem;

		&:after {
			content: '';
			display: block;
			clear: both;
		}
	}

	.statistics__contents__header__status {
		padding: 0.25em 1em;
		border: 1px solid #dfe6ee;
		margin-left: 1em;
		border-radius: 5px;
		vertical-align: middle;
		font-size: 0.875rem;
	}

	.statistics__contents__header__status--open {
		background-color: $btn-blue;
		border: solid 1px $btn-blue;
		font-weight: bold;
		color: #fff;
	}

	.statistics__contents__header__excel-download {
		position: relative;
		top: -8px;
		float: right;
	}

	.statistics__contents__table__total {
		background: #f4f7fa;
		color: #657088;
		font-weight: bold;
	}

	.statistics__button-wrapper {
		padding: 2em 0;
		text-align: right;

		button {
			display: inline-block;
		}
	}
</style>
